/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { createFileRoute, Outlet } from '@tanstack/react-router'
import { ChatRealtimeProvider } from '@web/src/features/chat/chat-realtime-context'
import { ChatInboxListener } from '@web/src/features/chat/hooks/use-chat-inbox'
import MainNavBar from '@web/src/features/main-nav-bar/main-nav-bar'

export const Route = createFileRoute('/(auth)/(chat-layout)')({
  // The Ably client is browser-only, and rendering the timeline on the server would
  // buy nothing here: every chat page is behind auth and excluded from indexing.
  ssr: false,
  component: Layout,
})

function Layout() {
  return (
    <>
      <MainNavBar />
      <ChatRealtimeProvider>
        <ChatInboxListener />
        <Outlet />
      </ChatRealtimeProvider>
    </>
  )
}
